export enum ScheduleRepeatTypesEnum {
	Never = 'a8e57225-392e-4f3a-bbb1-69032f32aa27',
	Daily = '3a248539-e00b-460f-8fa7-e91ece6589ea',
	Weekly = '44942eaf-c312-4c21-8037-faf83334076c',
	Monthly = '3ee4ce5e-1e45-4de4-9370-247f141e0d83',
}
